export default __webpack_public_path__ + "static/media/elastic.951c09a4.svg";